export default "__VITE_ASSET__NybRDoBc__"